import React, { useMemo } from 'react';
import { X } from 'lucide-react';
import ThreadedComment from './ThreadedComment';
import TeamResponses from './TeamResponses';

// In CommentModal.jsx, update the modal structure
const CommentModal = ({ 
  isOpen, 
  onClose, 
  feature,
  comments = [], 
  onCommentAdd, 
  onReactionAdd,
  reactions,
  currentUser,
  featureRef,
  teamResponses = [],
  userResponse,
  onResponseChange,
  organization
}) => {
  if (!isOpen) return null;

  const handleCommentSubmit = (e) => {
    const text = e.target.value.trim();
    if (e.key === 'Enter' && !e.shiftKey && text) {
      e.preventDefault();
      onCommentAdd(featureRef, text);
      e.target.value = '';
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center overflow-hidden">
      <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] m-4 flex flex-col">
        {/* Modal Header */}
        <div className="flex justify-between items-center p-4 border-b flex-shrink-0">
          <h2 className="text-xl font-semibold">Discussion</h2>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Feature Context Section */}
        <div className="p-4 flex-shrink-0">
          <h3 className="text-lg font-medium text-gray-900 mb-2">{feature.name}</h3>
          <p className="text-sm text-gray-600 mb-4">{feature.description}</p>
          
          {/* Team Responses for the Organization */}
          
        </div>

        {/* Modal Body - Comments */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {comments.length === 0 ? (
            <p className="text-gray-500 text-center py-4">
              No comments yet. Be the first to comment!
            </p>
          ) : (
            comments.map(comment => (
              <ThreadedComment
                key={comment.id}
                comment={comment}
                onReply={(parentId, text) => onCommentAdd(featureRef, text, parentId)}
                onReaction={onReactionAdd}
                currentUser={currentUser}
                reactions={reactions}
              />
            ))
          )}
        </div>

        {/* Modal Footer - New Comment Form */}
        <div className="border-t p-4 flex-shrink-0">
          <textarea
            placeholder="Add a comment... (Press Enter to submit, Shift+Enter for new line)"
            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
            rows={3}
            onKeyDown={handleCommentSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default CommentModal;
